import { Reveal } from './Reveal';

const MODES = [
    {
        title: 'Coaching Gimnasio',
        text: 'Entrena en el gimnasio que mejor se adapte a ti. Te puedo recomendar opciones y diseñar tu entrenamiento de acuerdo con tus objetivos y el equipo disponible.',
        testid: 'modality-gym-card',
    },
    {
        title: 'Coaching Online',
        text: 'Entrena desde donde estés, con un plan completamente personalizado y seguimiento de todo tu proceso.',
        testid: 'modality-online-card',
    },
];

export const Modalidades = () => (
    <section id="modalidades" className="py-24 px-6 bg-ink2 text-paper" data-testid="modalidades-section">
        <div className="max-w-[1080px] mx-auto">
            <Reveal className="max-w-[560px] mb-14">
                <p className="text-roselight text-sm uppercase tracking-[0.12em] font-semibold mb-4"><span className="text-xs align-middle">✦</span>&nbsp; Modalidades</p>
                <h2 className="font-serif font-normal text-[clamp(1.9rem,4vw,2.6rem)]" data-testid="modalidades-title">
                    Entrena donde quieras.
                </h2>
            </Reveal>
            <div className="grid md:grid-cols-2 gap-4">
                {MODES.map((m, i) => (
                    <Reveal key={m.title} delay={i * 0.1}>
                        <div
                            data-testid={m.testid}
                            className="bg-paper/[0.04] border border-paper/[0.14] rounded-2xl p-7 h-full hover:bg-paper/[0.08] hover:border-roselight hover:-translate-y-1 transition-all duration-300"
                        >
                            <span className="block text-[0.7rem] uppercase tracking-[0.12em] text-gold font-bold mb-3.5">Modalidad</span>
                            <h3 className="font-serif font-normal text-xl mb-2.5">{m.title}</h3>
                            <p className="text-[#C7C3BD] font-light text-[0.88rem]">{m.text}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
